import type { SymbolRenderProps } from '../types';

const TIP_LENGTH = 2.5;
const TIP_HALF_HEIGHT = 1.5;
const SHAFT_WIDTH = 0.4;

export function ArrowSingle({ shaftLength }: SymbolRenderProps) {
  const halfShaft = shaftLength / 2;
  const tipX = halfShaft;
  const shaftEndX = tipX - TIP_LENGTH;

  return (
    <g>
      <line
        x1={-halfShaft} y1={0}
        x2={shaftEndX} y2={0}
        stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      <polygon
        points={`${tipX},0 ${shaftEndX},${-TIP_HALF_HEIGHT} ${shaftEndX},${TIP_HALF_HEIGHT}`}
        fill="black"
      />
    </g>
  );
}
